export const styles = {
  dialog: {
    width: '90%',
    maxWidth: 1100,
  },
  dialogSmall: {
    width: 'auto',
    maxWidth: 600,
  },
  dialogTitle: {
    padding: '17px 24px',
    width: '100%',
    display: 'flex',
    MsFlexAlign: 'center',
    alignItems: 'center',
    fontFamily: 'Cairo',
    fontWeight: 600,
    userSelect: 'none',
    fontSize: 40,
    color: '#1f266b',

    '&:before': {
      content: '""',
      width: 100,
      height: 33,
      backgroundColor: '#1f266b',
      marginRight: 28,
      marginLeft: -24,
      marginTop: 3,
    },
  },
  dialogTitleSmall: {
    fontSize: 27,
    '&:before': {
      width: 70,
      height: 25,
      marginRight: 25,
    },
  },
  dialogContent: {
    color: '#4a4a4a',
    fontFamily: 'Montserrat',
    fontSize: 19,
    lineHeight: 1.25,
    letterSpacing: 0.5,
    marginBottom: 15,
  },

  '@media (max-width: 768px)': {
    dialog: {
      width: '100%',
      margin: 10,
    },

    dialogTitle: {
      padding: '9px 10px',
      fontSize: 27,

      '&:before': {
        height: 20,
        marginLeft: -65,
        marginRight: 20,
      },
    },
  },

  '@media (max-width: 440px)': {
    dialogTitle: {
      padding: '9px 19px',
      fontSize: 24,

      '&:before': {
        display: 'none',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/DialogApp/styles.js